export class CreateUpdateTherapist {
  public Id: number;
  public FullName: string;
  public TreatmentTypeIds: number[];
}
